module.exports = __webpack_public_path__ + "img/4-2.690344e8.png";